module.exports = {"title":"REMIX","background":"/assets/screenshot-2019-01-21-at-17.54.50.png","color":"#fff","type":"feed","stream_url":""}